<template>
    <div v-on:click="close()" id="photocard">
        <div class="left-column">
            <img class="fullimg" :src="photoUrl()">
        </div>
        <div class ="right-column">
            <div class="photo-info">
                    <div class ="text">
                        <p>{{ this.title }} </p>
                        <p>album {{ this.album }}</p>
                    </div>
                <button v-on:click="close()"> close </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'photo-card',
    props: ['title','album'],
    created(){
        this.title = this.$route.params.photo.title;
        this.album = this.$route.params.photo.albumId;
    },
    methods: {
        photoUrl(){
            return this.$route.params.id;
        },
        close(){
            this.$router.push({path: '/'})
        }
    }
}
</script>

<style scoped>
.photocard {
    display: inline-grid;
    float: left;
    min-width: 700px;
}
.left-column {
    margin-top: 30px;
    margin-left: 30px;
    width: 400px;
}
.right-column {
    width: 30vw;
    right: 0;
    height: 60vh;
    margin-top: 120px;
    margin-left: 10px;
    text-align: left;
}
p {
    color: white;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 15px;
    height: 20px;
    padding: 5px;
}
.text {
    background-color: #263238;
}
.photo-info {
    display: inline-block;

}
.fullimg {
    justify-content: center;
    margin-top: 10px;
    max-height: 400px;
    max-width: 400px;
}
button {
    background-color: #263238;
    border-color: #263238;
    color: white;
    margin-top: 190px;
}

</style>